import axios from 'axios';

export async function search(
  filters: Record<string, unknown>
): Promise<App.Surveys.Data.SurveyData[]> {
  return axios.get(route('api.surveys.search', filters)).then((res) => res.data);
}
